import { Alert, TextField } from "@mui/material";
import { useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AliasNeeded(props) { const [alias, setAlias] = useState(props.project.nameAlias || ''); if (props.project.nameAlias)
    return null; return /*#__PURE__*/ _jsxs(Alert, { severity: "warning", children: [/*#__PURE__*/ _jsx("div", { style: { paddingBottom: 10 }, children: "This project does not have a name alias.  This is the real project name will be displayed to vendors if you don't set this." }), /*#__PURE__*/ _jsx(TextField, { label: "Choose Alias", variant: "outlined", value: alias, onChange: e => { const value = e.currentTarget.value; setAlias(value); if (!value) {
                props.onChange(null);
            }
            else {
                props.onChange({ updateNeeded: true, value: value });
            } } })] }); }
